
import React, { useEffect, useState, useCallback } from 'react';
import { container } from 'op/container';
import { compose, withState, defaultProps } from 'recompose';
import styled from 'styled-components';
import { hot } from 'react-hot-loader';
import { Modal, Header, Button, Menu, Message } from 'semantic-ui-react';
import { Divider, Icon, Flag, Label, Grid, Segment } from 'semantic-ui-react';

import { withLocale } from 'op/components/locale';
import { withSettingsModel } from './settings-modal.helper';
import { withOnlineStatus } from 'op/components/offline';
import axios from "axios";

const ActionContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
`;

const StyledMenu = styled(Menu)`
	justify-content: space-between;
`;

const SettingsModal = ({ trigger, openModal, setOpenModal, available, locale, setCurrentLocale, clearLocalData, online }) => {
	const navigate = useCallback((url) => {
		container.resolve('history').push(url);
	});
	const [fieldValue, setFieldValue] = useState();
	useEffect(() => {
		axios.get('/api/common/terms').then(response => {
			setFieldValue(response.data.version);
		}).catch(ex => console.log(ex.message));
	}, []);
	return (
		<Modal closeIcon
			open={openModal}
			trigger={
				trigger(() => setOpenModal(true))
			}
			onClose={() => setOpenModal(false)}
		>
			<Header icon='settings' content='Settings' />
			<Modal.Content>
				<Grid>
					<Grid.Row columns={1}>
						<Grid.Column>
							<Header as='h4' color='teal' content='Language' />
							<StyledMenu fluid compact icon='labeled'>
								<div style={{ display: 'flex', flexDirection: 'row' }}>
									{
										available.map(language => (
											<Menu.Item
												key={language.short}
												name={language.short}
												active={language.short === locale._meta.short}
												onClick={() => {
													setCurrentLocale({ language });
													setOpenModal(false);
													navigate('/');
												}}
											>
												<Flag name={language.flag} />
												{language.name}
											</Menu.Item>
										))}
								</div>
								<div style={{ display: 'flex', flexDirection: 'row-reverse', width: '100%' }}>
									<Menu.Item
										key="stpthresholds"
										name="stpthresholds"
										active={false}
										onClick={() => {
											setOpenModal(false);
											navigate('/stpthresholds');
										}}
									>
										<Icon name='settings' />
										STP Thresholds
									</Menu.Item>
								</div>
							</StyledMenu>
						</Grid.Column>
					</Grid.Row>
					<Divider />
					<Grid.Row columns={1}>
						<Grid.Column>
							<Message negative>
								<Message.Header>Clear Local Data from Device</Message.Header>
								<p>This is pretty much factory reset. Once the cache is cleared all saved reports will be lost</p>
								<ActionContainer>
									<Button color='red' content='Clear Local Data' disabled={!online} onClick={clearLocalData} />
								</ActionContainer>
							</Message>
						</Grid.Column>
					</Grid.Row>
					<Divider />
					<Grid.Row columns={1}>
						<Grid.Column>{fieldValue}  </Grid.Column>
					</Grid.Row>
				</Grid>
			</Modal.Content>
		</Modal>);
};

export default compose(
	withSettingsModel,
	withOnlineStatus,
	hot(module),
)(SettingsModal);
